import type { CourseCategory, CourseSubCategory } from "@brookbush/types";

import { useRouter } from "next/compat/router";
import { parseAsString, useQueryState } from "next-usequerystate";
import useSWR, { type SWRResponse } from "swr";

import { constructQueryString } from "~/utils/helpers";

const useCourseCategory = () => {
	const [accreditationFilter] = useQueryState("accreditation", parseAsString);

	const { slugs } = (useRouter()?.query ?? {}) as {
		slugs: string[];
	};

	const queryString = constructQueryString([
		{
			key: "accreditation",
			value: accreditationFilter,
		},
	]);

	return useSWR(
		`/courses/categories/${slugs.join("/")}${queryString}`,
	) as SWRResponse<CourseCategory | CourseSubCategory> & {
		data: CourseCategory | CourseSubCategory;
	};
};

export default useCourseCategory;
